/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Group_DiscoverInputs */

const en_directory_agent_readiness_group_discover = /** @type {(inputs: Directory_Agent_Readiness_Group_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover and verify`)
};

const zh_directory_agent_readiness_group_discover = /** @type {(inputs: Directory_Agent_Readiness_Group_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现与验证`)
};

/**
* | output |
* | --- |
* | "Discover and verify" |
*
* @param {Directory_Agent_Readiness_Group_DiscoverInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_group_discover = /** @type {((inputs?: Directory_Agent_Readiness_Group_DiscoverInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Group_DiscoverInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_group_discover(inputs)
	return zh_directory_agent_readiness_group_discover(inputs)
});
export { directory_agent_readiness_group_discover as "directory.agent_readiness.group.discover" }